module.exports = __webpack_public_path__ + "static/media/btn2.7e4a76bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/btn2.png
// module id = 1218
// module chunks = 0